
const defaultCallback = (arg: string): boolean => false;

export const capitalizeFirstLetter = (word: string, locale = navigator.language, falseyCallback: (a: string) => Boolean = defaultCallback) => {
  if (!word || falseyCallback(word)) return '';
  const [first, ...rest] = word;
  return `${ first.toLocaleUpperCase(locale) }${ rest.reduce((acc, word) => acc += lowerCase(word), '') }`;
}

const lowerCase = (word: string) => (!word) ? '' : word.toLowerCase();
